var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({attrs:{"size":"16","color":"yellow"},on:{"click":_vm.getRowDiffProduct}},on),[_vm._v(" mdi-alert ")])]}}])},[_c('span',[_vm._v("Modified")])])}
var staticRenderFns = []

export { render, staticRenderFns }